import { Component } from '@angular/core';

@Component({
  selector: 'clear-input-icon',
  standalone: false,
  templateUrl: './clear-input-icon.component.html'
})
export class ClearInputIconComponent {
}